/** Opciones de zoom/pan para Chart.js (chartjs-plugin-zoom). */

export function isChartZoomType(type) {
  return type === 'line' || type === 'bar' || type === 'scatter';
}

export function buildChartZoomPluginOptions({ enabled, type }) {
  if (!enabled || !isChartZoomType(type)) return undefined;

  const mode = type === 'scatter' ? 'xy' : 'x';

  return {
    pan: {
      enabled: true,
      mode,
      threshold: 8,
    },
    zoom: {
      wheel: {
        enabled: true,
        speed: 0.08,
        modifierKey: null,
      },
      pinch: {
        enabled: true,
      },
      drag: {
        enabled: false,
      },
      mode,
    },
    limits: {
      x: { min: 'original', max: 'original', minRange: 2 },
      ...(mode === 'xy' ? { y: { min: 'original', max: 'original' } } : {}),
    },
  };
}
